(function () {
  var STICKY_MQ = '(min-width: 990px)';
  var MOBILE_MQ = '(max-width: 989px)';

  function formatCtaHtml(text) {
    if (!text) return '';
    return text.replace(
      /\(Subscribe\s*&(?:amp;)?\s*Save\)/i,
      '<span class="juno-product__cta-text--light">(Subscribe &amp; Save)</span>'
    );
  }

  function initSection(section) {
    initPlanSelector(section);
    initRightColumnSticky(section);
    initMobileFab(section);
  }

  function initRightColumnSticky(section) {
    var rightCol = section.querySelector('[data-products-right]');
    if (!rightCol || rightCol.dataset.junoStickyBound === 'true') return;

    rightCol.dataset.junoStickyBound = 'true';

    var mq = window.matchMedia(STICKY_MQ);
    var pinStart = 0;
    var ticking = false;

    function getBottomGap() {
      var value = getComputedStyle(section).getPropertyValue('--jp-sticky-bottom').trim();
      return value ? parseFloat(value) : 24;
    }

    function updateHeight() {
      if (!mq.matches) {
        section.style.removeProperty('--jp-right-height');
        return;
      }

      section.style.setProperty('--jp-right-height', rightCol.offsetHeight + 'px');
    }

    function measurePinStart() {
      section.classList.remove('is-right-pinned');

      if (!mq.matches) {
        pinStart = 0;
        return;
      }

      var gap = getBottomGap();
      var rightBottomDoc = window.scrollY + rightCol.getBoundingClientRect().bottom;
      pinStart = rightBottomDoc - (window.innerHeight - gap);
    }

    function updatePin() {
      ticking = false;

      if (!mq.matches) {
        section.classList.remove('is-right-pinned');
        return;
      }

      var scrollY = window.scrollY;
      var sectionRect = section.getBoundingClientRect();
      var shouldPin = scrollY >= pinStart && sectionRect.bottom > 0;

      section.classList.toggle('is-right-pinned', shouldPin);
    }

    function requestPinUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updatePin);
      }
    }

    function remeasure() {
      updateHeight();
      measurePinStart();
      requestPinUpdate();
    }

    remeasure();

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(remeasure);
      resizeObserver.observe(rightCol);
    }

    mq.addEventListener('change', remeasure);
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('scroll', requestPinUpdate, { passive: true });

    rightCol.addEventListener(
      'toggle',
      function (event) {
        if (event.target.tagName === 'DETAILS') remeasure();
      },
      true
    );
  }

  function initPlanSelector(section) {
    var planInputs = section.querySelectorAll('[data-juno-plan-input]');
    var sellingPlanField = section.querySelector('[data-juno-selling-plan]');
    var ctaTextEl = section.querySelector('[data-juno-cta-text]');
    var fabTextEl = section.querySelector('[data-juno-fab-text]');
    if (!planInputs.length) return;

    function syncIncludedLists(sectionEl, selectedPlan) {
      var includedRoot = sectionEl.querySelector('[data-juno-included]');
      if (!includedRoot) return;

      var subList = includedRoot.querySelector('[data-juno-included-list="subscription"]');
      var oneoffList = includedRoot.querySelector('[data-juno-included-list="oneoff"]');

      if (subList) subList.hidden = selectedPlan !== 'sub';
      if (oneoffList) oneoffList.hidden = selectedPlan !== 'oneoff';
    }

    function syncSelection() {
      var selectedPlan = 'oneoff';

      planInputs.forEach(function (input) {
        var label = input.closest('[data-juno-plan]');
        if (label) label.classList.toggle('is-selected', input.checked);

        if (input.checked) {
          selectedPlan = input.value;
          if (sellingPlanField) sellingPlanField.value = input.dataset.planId || '';
          if (input.dataset.ctaText) {
            var html = formatCtaHtml(input.dataset.ctaText);
            if (ctaTextEl) ctaTextEl.innerHTML = html;
            if (fabTextEl) fabTextEl.innerHTML = html;
          }
        }
      });

      syncIncludedLists(section, selectedPlan);
    }

    planInputs.forEach(function (input) {
      input.addEventListener('change', syncSelection);
    });

    var productForm = section.querySelector('form[data-type="add-to-cart-form"]');
    if (productForm && productForm.dataset.junoPlanSubmitBound !== 'true') {
      productForm.dataset.junoPlanSubmitBound = 'true';
      productForm.addEventListener(
        'submit',
        function () {
          syncSelection();
        },
        true
      );
    }

    syncSelection();
  }

  function initMobileFab(section) {
    var fab = section.querySelector('[data-juno-fab]');
    var plans = section.querySelector('[data-juno-plans]');
    if (!fab || !plans || fab.dataset.junoFabBound === 'true') return;

    fab.dataset.junoFabBound = 'true';

    var mq = window.matchMedia(MOBILE_MQ);
    var productsSecond = document.querySelector('[data-products-second]');
    var ticking = false;

    function setFabVisible(visible) {
      fab.classList.toggle('is-visible', visible);
      fab.setAttribute('aria-hidden', visible ? 'false' : 'true');
      fab.tabIndex = visible ? 0 : -1;
    }

    function updateFab() {
      ticking = false;

      if (!mq.matches || !productsSecond) {
        setFabVisible(false);
        return;
      }

      var secondRect = productsSecond.getBoundingClientRect();
      var plansRect = plans.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Show once products-second is near/in view (user has scrolled past buy box)
      var reachedSecond = secondRect.top < vh * 0.9;
      // Hide while plan options are already on screen
      var plansVisible = plansRect.top < vh * 0.75 && plansRect.bottom > vh * 0.2;

      setFabVisible(reachedSecond && !plansVisible);
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateFab);
      }
    }

    fab.addEventListener('click', function () {
      plans.scrollIntoView({ behavior: 'smooth', block: 'center' });

      window.setTimeout(function () {
        try {
          plans.focus({ preventScroll: true });
        } catch (error) {
          plans.focus();
        }
      }, 350);
    });

    mq.addEventListener('change', requestUpdate);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  }

  function initAll() {
    document.querySelectorAll('.juno-product').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.juno-product');
    if (section) {
      var fab = section.querySelector('[data-juno-fab]');
      if (fab) fab.dataset.junoFabBound = 'false';
      initSection(section);
    }
  });
})();
